export default {
  buildings: {
    human: {
      WALL: "wall",
      COMMAND_CENTER: "command_center",
      CULTIVATION_CENTER: "cultivation_center",
      ACADEMY: "academy",
      MISSILE_SILO: "missile_silo",
    },
    zombie: {
      HATCHERY: "hatchery",
      PUTREFACTOR: "putrefactor",
      EVOLUTION_CHAMBER: "evolution_chamber",
      TUNNEL: "tunnel",
    },
  },
  units: {
    human: {
      WORKER: "worker",
      SOLDIER: "soldier",
      RANGER: "ranger",
      TANK: "tank",
      ELITE: "elite",
      MEDIC: "medic",
      HELICOPTER: "helicopter",
    },
    zombie: {
      ZOMBIE: "zombie",
      CURSED: "cursed",
      DESTRUCTOR: "destructor",
      TITAN: "titan",
      WALKER: "walker",
      AMBUSHER: "ambusher",
      DOG: "dog",
    },
  },
}
